import { Badge, BadgeProps } from "@chakra-ui/react";

export interface BooleanBadgeProperties extends BadgeProps {
  value?: boolean;
}

export const BooleanBadge = ({ value, ...rest }: BooleanBadgeProperties): React.ReactElement => {
  return (
    <Badge
      variant={value ? "active" : "inactive"}
      {...rest}
      data-testid={value ? "boolean-badge-active" : "boolean-badge-inactive"}
    >
      {value ? "OUI" : "NON"}
    </Badge>
  );
};
